import { Link, NavLink, Outlet } from 'react-router-dom';
import { CRM_PIPELINE_STATUSES } from '@bcc/shared';
import { ROLES } from '@bcc/shared';
import { useAuth } from '../contexts/AuthContext';
import { SITE_GLASS_CARD } from '../constants/siteUi';

const sub = ({
  isActive,
}: {
  isActive: boolean;
}) =>
  `block rounded-lg px-3 py-2 text-sm transition ${
    isActive
      ? 'bg-[var(--home-miami-blue)]/[0.2] font-medium text-[var(--home-text-on-dark)] ring-1 ring-white/12'
      : 'text-[var(--home-muted-on-dark)] hover:bg-white/[0.06] hover:text-[var(--home-text-on-dark)]'
  }`;

export function AdminLayout() {
  const { role } = useAuth();

  return (
    <div className="mx-auto flex max-w-[1400px] flex-col gap-10 px-4 py-10 md:px-6 lg:flex-row">
      <aside className={`${SITE_GLASS_CARD} shrink-0 space-y-6 p-5 lg:w-56`}>
        <div>
          <p className="mb-2 text-[10px] uppercase tracking-[0.2em] text-[var(--home-muted-on-dark)]">Portal</p>
          <nav className="space-y-1">
            {role === ROLES.ADMIN ? (
              <NavLink to="/admin" end className={sub}>
                Dashboard
              </NavLink>
            ) : null}
            {role === ROLES.ADMIN ? (
              <NavLink to="/admin/upload-deal" className={sub}>
                Upload deal
              </NavLink>
            ) : null}
            <NavLink to="/admin/deals-catalog" className={sub}>
              Deal catalog
            </NavLink>
            {role === ROLES.ADMIN ? (
              <NavLink to="/admin/active-deal" className={sub}>
                Active deal page
              </NavLink>
            ) : null}
          </nav>
        </div>
        <div>
          <p className="mb-2 text-[10px] uppercase tracking-[0.2em] text-[var(--home-miami-blue)]">
            Analysis &amp; resources
          </p>
          <nav className="space-y-1">
            <NavLink to="/dashboard/analyzer" className={sub}>
              Deal analyzer
            </NavLink>
            <NavLink to="/dashboard/saved-analyses" className={sub}>
              Saved analyses
            </NavLink>
            <NavLink to="/dashboard/resources" className={sub}>
              Resources
            </NavLink>
            {role === ROLES.ADMIN ? (
              <NavLink to="/admin/ai-api-settings" className={sub}>
                AI API Settings
              </NavLink>
            ) : null}
            {role === ROLES.ADMIN ? (
              <NavLink to="/admin/deal-analyzer-prompt" className={sub}>
                Deal Analyzer prompt
              </NavLink>
            ) : null}
          </nav>
        </div>
        <div>
          <p className="mb-2 text-[10px] uppercase tracking-[0.2em] text-[var(--home-miami-blue)]">Marketing</p>
          <nav className="space-y-1">
            <NavLink to="/admin/events" className={sub}>
              Events &amp; RSVPs
            </NavLink>
            <NavLink to="/admin/leads" className={sub}>
              Leads
            </NavLink>
            <NavLink to="/admin/leads/pipeline" className={sub}>
              Lead pipeline
            </NavLink>
            <NavLink to="/admin/drip-campaigns" className={sub}>
              Drip Campaigns
            </NavLink>
            <NavLink to="/admin/resources" className={sub}>
              Article CMS
            </NavLink>
          </nav>
        </div>
        <div>
          <p className="mb-2 text-[10px] uppercase tracking-[0.2em] text-[var(--home-miami-blue)]">CRM</p>
          <nav className="space-y-1">
            <NavLink to="/admin/crm" end className={sub}>
              Overview
            </NavLink>
            <NavLink to="/admin/crm/deals" className={sub}>
              Pipeline deals
            </NavLink>
            <NavLink to="/admin/crm/contacts" className={sub}>
              Contacts
            </NavLink>
            <NavLink to="/admin/crm/pipeline" className={sub}>
              Pipeline board
            </NavLink>
          </nav>
        </div>
        <p className="text-[11px] leading-relaxed text-[var(--home-muted-on-dark)]">
          Stages: {Object.values(CRM_PIPELINE_STATUSES).join(' → ')}
        </p>
        <Link
          to="/deals"
          className="text-xs font-medium text-[var(--home-miami-blue)] underline-offset-4 hover:underline"
        >
          ← Public offerings
        </Link>
      </aside>
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
